import { lazy } from "react";
import { PATHS } from "@/lib/router";

const BillOcrPage = lazy(() =>
  import("./pages/BillOcrPage").then((m) => ({ default: m.BillOcrPage })),
);

export const billOcrRoutes = [
  {
    path: PATHS.BILL_OCR,
    element: <BillOcrPage />,
    handle: { permission: { resource: "esg_data_entry", action: "view" } },
  },
];
